import { PublicationStatus } from '@/types/questionnaire'
import { Gender, ReceiptSupplier } from '@/types/receipt'
import { QuestionnaireAnswerState, RootState } from '@/types/store'
import { Module } from 'vuex'

import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

const state: QuestionnaireAnswerState = {
  isQuestionnaireAnswerLoading: false,
  questionnaireAnswer: {
    id: -1,
    createdAt: '',
    updatedAt: '',
    deletedAt: null,
    answerId: '',
    monitorId: '',
    receiptId: null,
    itemId: null,
    imageId: '',
    answeredAt: '',
    openedAt: '',
    ngReason: null,
    defectReason: null,
    messageToAdmin: null,
    adminComment: null,
    checkedBy: null,
    checkerCheckStatus: 'non',
    checkerCheckedAt: null,
    adminCheckStatus: 'non',
    adminCheckedAt: null,
    questionnaireId: -1,
    questionnaire: {
      id: -1,
      name: '',
      nameAdmin: '',
      status: PublicationStatus.PUBLIC,
      releaseAt: null,
      releasedAt: null,
      finishAt: null,
      finishedAt: null,
      publicTime: null,
      comment: '',
      description: '',
      isRequiredCheck: false,
      rewardPoint: -1,
      totalLimitDisplay: null,
      totalLimit: null,
      resetLimit: null,
      pobCategoryIds: [],
      targetCodes: [],
      dailyUpperLimitByJan: -1,
      dailyUpperLimitByChain: -1,
      chainStoreIds: [],
      dailyUpperLimit: -1,
      answerUpperLimit: -1,
      targetSupplier: ReceiptSupplier.WED,
      targetGender: Gender.FEMALE,
      targetUpperLimitAge: -1,
      targetLowerLimitAge: -1,
      targetPrefecture: [],
      targetMarriage: null,
      createdById: -1,
      createdAt: '',
      updatedAt: '',
      deletedAt: null,
      pages: [],
      isAutomatic: true,
      isWelcome: false,
      finishDuration: null,
      memberCodes: [],
      fixedQuestionnaireUrl: '',
      imageUrl: '',
      reachedToLimitAt: null,
      parent: null,
      parentId: null,
    },
    questionAnswers: [],
  },
  receipt: null,
  questionnaireAnswers: [],
}

export const questionnaireAnswer: Module<
  QuestionnaireAnswerState,
  RootState
> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
